/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Cervix from './cervix';
import CervixDetail from './cervix-detail';
import CervixUpdate from './cervix-update';
import CervixDeleteDialog from './cervix-delete-dialog';

const CervixRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Cervix />} />
    <Route path="new" element={<CervixUpdate />} />
    <Route path=":id">
      <Route index element={<CervixDetail />} />
      <Route path="edit" element={<CervixUpdate />} />
      <Route path="delete" element={<CervixDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CervixRoutes;
